import { api } from "assets/scripts/utilities/api-clients";

import { omitKeys } from "src/assets/scripts/utilities/helpers";

const preparePOD = (payload) => {
  payload = omitKeys(payload, ["invoice"]);

  return payload;
};

export const cancel = async (params) => {
  const { pod, removeFiles, path = "kam" } = params;
  const endpoints = {
    kam: {
      pod: {
        cancel: "/kam/pods",
      },
    },
    account: {
      pod: {
        cancel: "/account/pods",
      },
    },
  };
  const response = await api.put(endpoints[path].pod.cancel, {
    _id: pod._id,
    reason: pod.reason,
    isFilesToBeRemoved: removeFiles,
  });

  return response;
};

export const get = async ({ id, source, options = {} }) => {
  const url = {
    kam: `/kam/pods/${id}`,
    sales: `/sales/pod/${id}`,
  };
  const response = await api.get(url[source], options);

  return response;
};

export const index = async (options = {}) => {
  const { source = "kam", ...rest } = options;
  const url = {
    kam: "/kam/pods",
    sales: "/sales/pods",
  };
  const response = await api.get(url[source], rest);

  return response;
};

export const post = async (
  pod,
  { params: { showMessage = false, ...restParams } = {}, ...restOptions } = {},
) => {
  const response = await api.post("/kam/pods", preparePOD(pod), {
    params: { showMessage, ...restParams },
    ...restOptions,
  });

  return response;
};

export const put = async (
  pod,
  { params: { showMessage = false, ...restParams } = {}, ...restOptions } = {},
) => {
  const response = await api.put("/kam/pods", pod, {
    params: { showMessage, ...restParams },
    ...restOptions,
  });

  return response;
};

export const checkNumber = async (number) => {
  const response = await api.post("/kam/pods/active", number);

  return response;
};
